import createReactComponent from '../createReactComponent';
export default createReactComponent('line', 'IconLine', [
  ['path', { d: 'M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0', key: 'svg-0' }],
  ['path', { d: 'M18 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0', key: 'svg-1' }],
  ['path', { d: 'M7.5 16.5l9 -9', key: 'svg-2' }],
]);
